import React, { Component } from 'react';
import { connect } from "react-redux";
import * as actions from "../../redux/actions";
import Shade from '../Shade/Shade';
import QuickLookBtn from '../LevarUI/QuickLookBtn';
import SceneViewerBtn from '../LevarUI/SceneViewerBtn';
import LevarLogo from '../LevarUI/LevarLogo';
import CloseBtn from '../LevarUI/CloseBtn';
import ViewQRbutton from "../LevarUI/ViewQRbutton";
import DisplayQRcode from '../LevarUI/DisplayQRcode';
import DisplayPrompt from '../LevarUI/DisplayPrompt';
import WebViewPrompt from '../LevarUI/WebViewPrompt';

class App extends Component {

  componentDidMount() {
    this.handlePrompt();
  };

  handlePrompt = () => {
    const { engine } = this.props;
    if(engine.quickLook || engine.sceneViewer) {
      setTimeout(() => { this.props.setPromptView(true) }, 1000)
    }
  };

  render() {
    const { shadeState, engine, origin } = this.props;
    let isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    return (
      <div className="App">
          <div className="viewer">
            {(engine.quickLook && shadeState === 'SHADE_READY') && <QuickLookBtn />}
            {(engine.sceneViewer && shadeState === 'SHADE_READY') && <SceneViewerBtn />}
            {(origin.length > 0 && shadeState === 'SHADE_READY') && <CloseBtn />}
            { shadeState === 'SHADE_READY' && <LevarLogo /> }
            <section className="Shade-Viewer">
              <Shade />
            </section>
            { (!isMobile && shadeState === 'SHADE_READY') && <ViewQRbutton /> }
            { this.props.viewQR && <DisplayQRcode /> }
            { (this.props.viewPrompt && shadeState === 'SHADE_READY') && <DisplayPrompt /> }
            { (this.props.webViewPrompt && shadeState === 'SHADE_READY') && <WebViewPrompt /> }
          </div>
      </div>
    );
  };
};

export const mapStateToProps = state => ({
  shadeState: state.shadeState,
  engine: state.engine,
  origin: state.origin,
  viewQR: state.viewQR,
  viewPrompt: state.viewPrompt,
  webViewPrompt: state.webViewPrompt,
});

export const mapDispatchToProps = dispatch => ({
  setPromptView: data => dispatch(actions.setPromptView(data)),
  setShadeReady: data => dispatch(actions.setShadeReady(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
